module.exports = __webpack_public_path__ + "img/actualizar.39903ca0.svg";